import { USE_FEDERATED_AUTH } from 'config';
import { useUser as useUserForms } from './formsAuthHooks';
import { useUser as useUserFederated } from './federatedAuthHooks';

export const useUser = () => {
  // The Forms session is a cookie shared with Delogue legacy, so it can change out from
  // under an idle tab (legacy logout/login, or the user clearing the cookie). Refetching on
  // focus is what lets CacheIdentityGuard notice a different user, 30s stale time is a
  // compromise to avoid spamming it
  const formsResult = useUserForms({ refetchOnWindowFocus: true, staleTime: 30000 });
  const federatedResult = useUserFederated();

  return USE_FEDERATED_AUTH ? federatedResult : formsResult;
};
